import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {

  constructor(private http: HttpClient) { }

  uploadFiles(efileApiUrl: string, path: string, files: File[]): Observable<any> {
    const fd = new FormData();
    files.forEach(file => fd.append('files', file));
    const url = `${efileApiUrl}/uploadFilesToDirectory?path=${encodeURIComponent(path)}`;
    return this.http.post(url, fd, {
      withCredentials: true
    });
  }

  viewFiles(efileApiUrl: string, path: string): Observable<any> {
    const url = `${efileApiUrl}/listFilesInDirectory?path=${encodeURIComponent(path)}`;
    return this.http.post(url, {}, { withCredentials: true });
  }

  deleteFile(efileApiUrl: string, path: string): Observable<any> {
    const url = `${efileApiUrl}/deleteFilesOrFolder?path=${encodeURIComponent(path)}`;
    return this.http.post(url, {}, { withCredentials: true });
  }
}
